import { DividerProps, Divider as MuiDivider } from "@mui/material";

type Props = DividerProps;

export const Divider = ({ children, ...props }: Props) => {
  return <MuiDivider {...props}>{children}</MuiDivider>;
};
